import { SecureStoragePlugin } from 'capacitor-secure-storage-plugin';
import { QueryClient } from '@tanstack/react-query';
import useCustomQuery from '../../../../core/useCustomQuery';
import { staleTimeForSession } from '../../../../core/reactQueryCore';
import useCustomMutation from '../../../../core/useCustomMutation';

export const eventTourCompletedKey = 'eventTourCompleted';

export const useGetEventTourCompleted = () =>
	useCustomQuery({
		queryKey: [eventTourCompletedKey],
		queryFn: async () => {
			return SecureStoragePlugin.get({ key: eventTourCompletedKey })
				.then((result) => result.value === 'true')
				.catch(() => false);
		},
		staleTime: staleTimeForSession
	});

export const useSetEventTourCompleted = (queryClient: QueryClient) =>
	useCustomMutation({
		mutationFn: async () => SecureStoragePlugin.set({ key: eventTourCompletedKey, value: 'true' }),
		onSuccess: async () => {
			await queryClient.invalidateQueries({ queryKey: [eventTourCompletedKey] });
		}
	});

export const useResetEventTourCompleted = (queryClient: QueryClient, onSuccess: () => void) =>
	useCustomMutation({
		mutationFn: async () => {
			try {
				const result = await SecureStoragePlugin.get({ key: eventTourCompletedKey });
				if (result?.value === undefined) {
					return;
				}
				await SecureStoragePlugin.remove({ key: eventTourCompletedKey });
			} catch {
				// Handle error if needed
			}
		},
		onSuccess: async () => {
			await queryClient.invalidateQueries({ queryKey: [eventTourCompletedKey] });
			onSuccess();
		}
	});
